import artifact from '$houdini/artifacts/UpdateExistingReportSubscription'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateExistingReportSubscriptionStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
